export function createBanco() {
  return {
    Clave: '',
    EmpresaId: 0,
    Nombre: '',
    NombreCompleto: '',
    CodigoBanco: '',
    ClaveInternacional: '',
    SwiftBic: '',
    AbaRouting: '',
    Pais: 'MEX',
    Moneda: 'MXN',
    ClaveErp: '',
    SitioWeb: '',
    Telefono: '',
    Observaciones: '',
    Orden: 0,
    EsSistema: false,
    EsActivo: true
  };
}
